import { render, staticRenderFns } from "./graphSwitch.vue?vue&type=template&id=70414a3a&scoped=true"
import script from "./graphSwitch.vue?vue&type=script&lang=js"
export * from "./graphSwitch.vue?vue&type=script&lang=js"
import style0 from "./graphSwitch.vue?vue&type=style&index=0&id=70414a3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70414a3a",
  null
  
)

export default component.exports